export default {
  AUTH: {
    LOGIN: 'api/auth/login',
    LOGOUT: 'api/auth/logout',
  },
  UPLOAD_FILE: 'api/admin/rental-spaces/upload-image-storage',
  CATEGORY_OF_SPACE: {
    GET_LIST_CATEGORY_SPACE_ALL: 'api/category-spaces/list-all',
    GET_LIST_CATEGORY_SPACE: 'api/category-spaces/list',
    CREATE_CATEGORY_SPACE: 'api/admin/category-spaces/create',
    GET_DETAIL_CATEGORY_SPACE: 'api/category-spaces/detail',
    DELETE_CATEGORY_SPACE: 'api/admin/category-spaces/delete',
    UPDATE_CATEGORY_SPACE: 'api/admin/category-spaces/update',
  },

  GET_LIST_SPACE: 'api/rental-spaces/list',
  GET_LIST_LOCATION: 'api/admin/location/list',
  NEWS: {
    GET_LIST_NEWS: 'api/admin/news/list',
    GET_DETAIL_NEWS: 'api/news/detail',
    CREATE_NEWS: 'api/admin/news/create',
    UPDATE_NEWS: 'api/admin/news/update',
  },
  CAMPAIGN: {
    GET_LIST_CAMPAIGN: 'api/admin/ts-campaign/list',
    GET_DETAIL_CAMPAIGN: 'api/admin/ts-campaign/detail',
  },
  SPACE_SUPPLIES: {
    GET_LIST_SUPPLIES: 'api/free-supplies/list',
    GET_DETAIL_SUPPLIES: 'api/free-supplies/detail',
    DELETE_SUPPLIES: 'api/admin/free-supplies/delete',
    CREATE_SUPPLIES: 'api/admin/free-supplies/create',
    UPDATE_SUPPLIES: 'api/admin/free-supplies/update',
  },
  EQUIPMENT_CATEGORIES: {
    GET_LIST_EQUIPMENT_CATEGORIES: 'api/equipment-categories/list',
  },
  BLOG: {
    GET_LIST: 'api/admin/blog/list',
    GET_DETAIL: 'api/admin/blog/detail',
    CREATE_BLOG: 'api/admin/blog/create',
    UPDATE_BLOG: 'api/admin/blog/update',
    CREATE_BLOG_TYPE: 'api/admin/blog_type/create',
    GET_LIST_BLOG_TYPE: 'api/admin/blog_type/list',
    DETAIL_BLOG_TYPE: 'api/admin/blog_type/detail',
    UPDATE_BLOG_TYPE: 'api/admin/blog_type/update',
    DELETE_BLOG_TYPE: 'api/admin/blog_type/delete',
    GET_LIST_BLOG_TAG: 'api/tag/list',
    CREATE_BLOG_TAG: 'api/admin/tag/create',
    DETAIL_BLOG_TAG: 'api/tag/detail',
    UPDATE_BLOG_TAG: 'api/admin/tag/update',
    DELETE_BLOG_TAG: 'api/admin/tag/delete',
  },
}
